import { debug } from './theme/debug.js';
import { helpers } from './theme/helpers.js';

import { hamburger } from './theme/components/hamburger.js';
import { sliders } from './theme/components/sliders.js';
import { vote } from './theme/components/vote.js';
import { loadPosts } from './theme/components/loadPosts.js';
import { modal } from './theme/components/modal.js';
import { news } from './theme/components/news.js';
import { loadMore } from './theme/components/load-more.js';

window.theme = {
	globals: {
		enablePjax: true,
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
	},
	init: function () {
		var theme = this;

		//Global
		theme.smoothScroll.init();
		theme.loginPage.init();
		// theme.responsiveBackgroundImage.init();

		hamburger.init();
		sliders.init();
		vote.init();
		loadPosts.init();
		modal.init();
		news.init();
		loadMore.init();

		document.querySelector('body').classList.add('loaded');

		if (theme.globals.isTouch === true) {
			document.querySelector('body').classList.add('touch-device');
		} else {
			document.querySelector('body').classList.add('pointer-device');
		}

		if (document.querySelector('#open-modal')) {
			document.querySelector('#open-modal').click();
		}

		$('.close-modal-for-good').on('click', function () {
			theme.setCookie('disable-modal-hp', true, 365);
		});
	},
	videoControls(element, event, id) {
		event.preventDefault();
		var self = this;

		var targetVideo = document.querySelector('#' + id);
		if (element.classList.contains('play')) {
			targetVideo.play();
			element.parentElement.parentElement.classList.add('is-playing');
		} else {
			targetVideo.pause();
			element.parentElement.parentElement.classList.remove('is-playing');
		}
	},
	loginPage: {
		selectors: {
			errors: '#login_error',
			bodyClass: 'login-action-password-protected-login',
			loginForm: '#loginform',
		},
		init: function () {
			var self = this;

			if (document.querySelector(self.selectors.errors)) {
				if (document.querySelector('body').classList.contains(self.selectors.bodyClass)) {
					jQuery(self.selectors.errors).prependTo(self.selectors.loginForm);
					jQuery(self.selectors.loginForm).addClass('errors_showed');
				}
			}
		},
	},
	smoothScroll: {
		selector: 'a[href*="#"]',
		init: function () {
			var self = this,
				scroll = new SmoothScroll(self.selector, {
					ignore: '[data-scroll-ignore]',
					topOnEmptyHash: false,
					speed: 1000,
					offset: 60,
					updateURL: false,
					easing: 'easeInOutCubic',
				});
		},
	},
	responsiveBackgroundImage: {
		selector: '*[data-mobile-background-image]',
		init: function () {
			var self = this,
				$elements = $(self.selector),
				viewportWidth = $(window).width();

			$elements.each(function () {
				var $element = $(this),
					mobileBackgroundImageUrl = $element.attr('data-mobile-background-image');

				if (viewportWidth <= 992) {
					$element.css('background-image', 'url("' + mobileBackgroundImageUrl + '")');
				}
			});
		},
	},
	setCookie(name, value, days) {
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	},
	getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},
	eraseCookie(name) {
		document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	},
};

jQuery(document).ready(function ($) {
	theme.init();
});
